import React, { useState, useEffect } from 'react';
import '../css/Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [sent, setSent]       = useState(false);

  /* 🎯  Parallax tilt: capture pointer and expose % coords to CSS vars  */
  useEffect(() => {
    const section = document.getElementById('contact');
    if (!section) return;
    const handleMove = (e) => {
      section.style.setProperty('--px', e.clientX / window.innerWidth);
      section.style.setProperty('--py', e.clientY / window.innerHeight);
    };
    window.addEventListener('pointermove', handleMove);
    return () => window.removeEventListener('pointermove', handleMove);
  }, []);

  const handleChange = (e) =>
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    /* 🔗  plug in EmailJS / backend here  */
    setSent(true);
    setTimeout(() => setSent(false), 3500); // reset after animation
    setFormData({ name: '', email: '', message: '' });
  };

  return (
    <section className="contact-section" id="contact">
      {/* 💫 Bubble background */}
      <div className="bubbles" />
      <div className="bubbles bubbles--2" />

      {/* 📬 Glass form card */}
      <h2 className="contact-title">Get in Touch</h2>

      <form onSubmit={handleSubmit} className={`contact-form ${sent ? 'sent' : ''}`}>
        <input
          type="text"
          name="name"
          placeholder="Your Name"
          value={formData.name}
          onChange={handleChange}
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Your Email"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <textarea
          name="message"
          placeholder="Your Message"
          value={formData.message}
          onChange={handleChange}
          rows="5"
          required
        />

        {/* 🚀 Launch button/animation */}
        <button type="submit" className="send-btn">
          <span className="btn-text">{sent ? 'Sent!' : 'Send'}</span>
          <span className="rocket" aria-hidden="true">🚀</span>
        </button>
      </form>
    </section>
  );
};

export default Contact;
